import {readonlyType} from '@raison/io-ts-tools';
import {HttpClient} from '@raison/network-facade';
import {TypeOf, string} from 'io-ts';

const LogoutResponseData = readonlyType({
    message: string,
});
export type LogoutResponseData = TypeOf<typeof LogoutResponseData>;

export const logoutWithToken = (http: HttpClient, maybeToken: string) => {
    return http('v1/logout', {
        method: 'POST',
        headers: {Authorization: `Bearer ${maybeToken}`},
    });
};
